import styled from "@emotion/styled"

export const StyledDescription = styled.div``

export const StyledTitle = styled.span``

export const StyledPage = styled.div`
  max-width: 21rem;
  text-align: center;
  margin: auto;
`

export const StyledPageContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr minmax(30rem, auto);

  @media only screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    grid-template-columns: 2fr minmax(50rem, auto);
  }
`

export const StyledLeftSide = styled.div`
  background-color: ${(p) => p.theme.colors.whiteSmoke};
`

export const StyledLeftContent = styled.div`
  margin: 2rem 0.5rem 2rem 2rem;
`
export const StyledRightContent = styled.div``
export const StyledRightSide = styled.div`
  margin: 2rem;

  @media only screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    margin: 4rem;
  }
`

export const StyledCategoryName = styled.div`
  font-family: ${(p) => p.theme.fontFamilies.regular};
  font-size: 1rem;
  font-style: normal;
  font-weight: ${(p) => p.theme.fontWeights.liteMedium};
  line-height: 1.5rem;

  @media only screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 1.5rem;
    line-height: 2.125rem;
  }
`
export const StyledCategoryNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  min-height: 3rem;
  &.selected {
    background-color: ${(p) => p.theme.colors.carrot};
    &,
    i {
      color: ${(p) => p.theme.colors.white};
    }
  }

  &.sub-selected {
    &,
    div {
      font-family: ${(p) => p.theme.fontFamilies.headline};
      font-weight: ${(p) => p.theme.fontWeights.semiBolder};
    }
  }
`

export const StyledSubcategoryNameContainer = styled.div`
  cursor: pointer;
`

export const StyledCategoryNameIcon = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: space-between;
  cursor: pointer;
  align-items: center;
`
export const StyledCategoryNameArrow = styled.div``

export const StyledCloseIcon = styled.div`
  position: absolute;
  right: 2rem;
  cursor: pointer;
  svg {
    width: 2rem;
    height: 2rem;
  }

  @media only screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    right: 4rem;
    svg {
      width: 4rem;
      height: 4rem;
    }
  }
`

export const StyledIcon = styled.div`
  color: ${(p) => p.theme.colors.pitchBlack};
  &,
  svg {
    width: 1.5rem;
  }
`

export const StyledSubCategoryName = styled.div`
  text-align: left;
  font-family: ${(p) => p.theme.fontFamilies.regular};
  font-size: 1rem;
  font-style: normal;
  font-weight: ${(p) => p.theme.fontWeights.liteMedium};
  line-height: 1.5rem;

  &.selected {
    font-family: ${(p) => p.theme.fontFamilies.headline};
    font-weight: ${(p) => p.theme.fontWeights.semiBolder};
  }

  @media only screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 1.5rem;
    line-height: 2.125rem;
  }
`
export const StyledCategoryTitle = styled.div`
  font-family: ${(p) => p.theme.fontFamilies.headline};
  font-size: 2rem;
  font-style: normal;
  font-weight: ${(p) => p.theme.fontWeights.semiBolder};
  line-height: 2.75rem;
  text-align: left;

  @media only screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 4rem;
    line-height: 5rem;
  }
`

export const StyledFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 2.5rem;
  background: ${(p) => p.theme.colors.carrot};
  color: ${(p) => p.theme.colors.white};
  border-radius: 0.25rem;
  cursor: pointer;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    height: 3.375rem;
  }
`

export const StyledFilterItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  color: ${(p) => p.theme.colors.white};
`

export const StyledLabel = styled.div`
  font-family: ${(p) => p.theme.fontFamilies.headline};
  font-weight: ${(p) => p.theme.fontWeights.semiBolder};
  font-size: 0.75rem;
  line-height: 1.125rem;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
`

export const StyledCategoryTitleMobile = styled.div`
  font-family: ${(p) => p.theme.fontFamilies.headline};
  font-size: 1.5rem;
  font-style: normal;
  font-weight: ${(p) => p.theme.fontWeights.semiBolder};
  line-height: 2.125rem;
  text-align: left;
  margin-left: 2rem;
  min-height: 1.5rem;
`

export const StyledPageContainerMobile = styled.div`
  margin-top: -1.75rem;
  line-height: 2.25rem;
`
export const StyledSelectedCategoryMobile = styled.div`
  cursor: pointer;
  div > input:disabled {
    background: ${(p) => p.theme.colors.white};
  }
`

export const StyledRegionContainer = styled.div`
  width: 100%;
  display: block;
  .react-select__option--is-selected {
    background-color:  ${(p) => p.theme.colors.whiteSmoke}; !important;
  }

 
  .selected{
    background-color:  ${(p) => p.theme.colors.whiteSmoke}; !important;
  }
`
export const StyledOption = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${(p) => p.theme.fontFamilies.regular};
  font-weight: ${(p) => p.theme.fontWeights.liteMedium};
  font-size: 0.75rem;
  line-height: 1rem;
  cursor: pointer;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 1rem;
    line-height: 1.375rem;
  }
`
export const StyledOptionLabel = styled.div`
  font-family: ${(p) => p.theme.fontFamilies.regular};
  font-size: 1rem;
  font-weight: ${(p) => p.theme.fontWeights.liteMedium};
  line-height: 1.5rem;
`

export const StyledOptionNumbers = styled.div`
  color: ${(p) => p.theme?.colors?.linkBlue};
  &.active {
    color: ${(p) => p.theme.colors.white};
  }
`
export const StyledGroupHeading = styled.div`
  text-align: left;
  font-family: ${(p) => p.theme.fontFamilies.headlineBig};
  font-weight: ${(p) => p.theme.fontWeights.liteBlack};
  color: ${(p) => p.theme.colors.pitchBlack};
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 0.25rem;
  margin-left: 0.25rem;
  text-transform: uppercase;

  @media screen and (min-width: ${(p) => p.theme.breakpoints.wide}) {
    font-size: 1rem;
    line-height: 1.5rem;
  }
`

export const StyledGroupHeadingIcon = styled.div`
  i {
    font-size: 1.5rem;
    font-weight: ${(p) => p.theme.fontWeights.liteBlack};
  }
  min-width: 2rem;
  color: ${(p) => p.theme.colors.carrot};
  text-align: center;
`

export const StyledGroupHeadingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
`
